import app from './app'
import auth from './auth'
import replenishmentRequests from './replenishment-requests'
import replenishmentRequestProducts from './replenishment-request-products'
import stations from './stations'
import deliveryRuns from './delivery-runs'
import drivers from './drivers'
import users from './users'
import printLogs from './print-logs'
import firefighters from './firefighters'
import orderRefunds from './orders/refunds'
import garmentAssets from './garments/assets'
import garmentLocations from './garments/locations'
import pendingStations from './delivery-runs/pending-stations'
import invoiceRuns from './invoice-runs'
import customers from './customers'
import xero from './xero'
import lists from './lists'
import inventories from './inventories'

export default {
  app,
  auth,
  replenishmentRequests,
  replenishmentRequestProducts,
  stations,
  deliveryRuns,
  drivers,
  users,
  printLogs,
  firefighters,
  orderRefunds,
  garmentAssets,
  garmentLocations,
  pendingStations,
  invoiceRuns,
  customers,
  lists,
  xero,
  inventories
}
